import { render, staticRenderFns } from "./EditSpecification.vue?vue&type=template&id=86256292&"
import script from "./EditSpecification.vue?vue&type=script&lang=js&"
export * from "./EditSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports